import { Controller } from "@hotwired/stimulus"

// Page d'un plan d'action : soumission des filtres, modale de partage, et
// mise à jour inline du statut / avancement des actions et des indicateurs
// depuis la vue tableau (suivi).
export default class extends Controller {
  static targets = ["shareModal", "shareMembers"]

  submitFilters(event) {
    const form = event.target.closest("form")
    if (form) form.requestSubmit()
  }

  openShare() {
    this.shareModalTarget?.classList.remove("pa-modal--hidden")
  }

  closeShare() {
    this.shareModalTarget?.classList.add("pa-modal--hidden")
  }

  toggleShareMembers(event) {
    if (!this.hasShareMembersTarget) return
    this.shareMembersTarget.hidden = event.target.value !== "shared"
    this.element.querySelectorAll(".pa-radio").forEach(r => {
      r.classList.toggle("is-active", r.querySelector("input")?.checked)
    })
  }

  async updateItem(event) {
    const el = event.currentTarget
    const field = el.dataset.field
    const value = el.value
    await this._patch(el.dataset.url, { plan_action_item: { [field]: value } }, el)
    if (field === "avancement") {
      const bar = el.closest(".pa-row")?.querySelector("[data-prog-bar]")
      if (bar) bar.style.width = Math.max(0, Math.min(100, parseInt(value || "0", 10))) + "%"
    }
  }

  async updateIndicator(event) {
    const el = event.currentTarget
    await this._patch(el.dataset.url, { plan_action_indicator: { valeur_actuelle: el.value } }, el)
  }

  async updateObjective(event) {
    const el = event.currentTarget
    await this._patch(el.dataset.url, { plan_action_objective: { valeur_actuelle: el.value } }, el)
    const cible = parseFloat(el.dataset.cible)
    if (!isNaN(cible) && cible !== 0) {
      const pct = Math.max(0, Math.min(100, Math.round((parseFloat(el.value || "0") / cible) * 100)))
      const bar = el.closest(".pa-objective")?.querySelector("[data-obj-bar]")
      if (bar) bar.style.width = pct + "%"
    }
  }

  async _patch(url, body, el) {
    if (!url) return
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content
    el?.classList.remove("is-saved", "is-error")
    el?.classList.add("is-saving")
    try {
      const res = await fetch(url, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", "Accept": "application/json", "X-CSRF-Token": csrf || "" },
        body: JSON.stringify(body)
      })
      el?.classList.remove("is-saving")
      el?.classList.add(res.ok ? "is-saved" : "is-error")
      setTimeout(() => el?.classList.remove("is-saved", "is-error"), 1200)
    } catch (e) {
      el?.classList.remove("is-saving")
      el?.classList.add("is-error")
    }
  }
}
